import script from "./VCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./VCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./VCheckbox.vue?vue&type=style&index=0&id=931dd91e&lang=scss"

const __exports__ = script;

export default __exports__